import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ContentComponent} from './layout/content/content.component';
import {LayoutModule} from './layout/layout.module';
import {I18nModule} from './i18n/i18n.module';
import {OnboardingComponent} from './views/onboarding/onboarding.component';
import {OnboardingCompletedComponent} from './views/onboarding-completed/onboarding-completed.component';
import {OnboardingResolverService} from './views/onboarding/onboarding-resolver.service';
import {CustomerConfigResolverService} from './views/onboarding/customer-config-resolver.service';
import {OnboardingInvalidComponent} from './views/onboarding-invalid/onboarding-invalid.component';
import {OnboardingGuard} from './views/onboarding.guard';

const routes: Routes = [
    {
        path: 'c',
        component: ContentComponent,
        canActivate: [OnboardingGuard],
        children: [
            {
                path: 'onboarding',
                component: OnboardingComponent,
                data: {title: 'Onboarding'},
                resolve: {
                    member: OnboardingResolverService,
                    customerConfig: CustomerConfigResolverService
                }
            },
            {
                path: 'onboarding-completed',
                component: OnboardingCompletedComponent,
                data: {title: 'Onboarding completed'}
            },
            {
                path: 'onboarding-invalid',
                component: OnboardingInvalidComponent,
                data: {title: 'Onboarding expired'}
            },
            {
                path: '',
                redirectTo: 'onboarding',
                pathMatch: 'full'
            }
        ],
        resolve: {}
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'c'
    },
    {
        path: '**',
        redirectTo: 'c'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
        // app
        LayoutModule,
        I18nModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
